/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { brandColors, themeColors } from "../../../Components/EOSThemeProvider"
import { ICustomerPrice } from "./CustomerPriceLoader"

export function ClearancePriceDisplay({
  price,
  isLoading,
  canViewPricing,
  size = "normal",
}: {
  price?: ICustomerPrice
  isLoading?: boolean
  canViewPricing?: boolean | null
  size?: "normal" | "large"
}) {
  const fontSize = size === "large" ? 18 : 14

  if (isLoading) {
    return <span css={css`color: ${themeColors.grey};`}>-</span>
  }

  if (!canViewPricing) {
    return <span css={css`font-weight: 200;`}>Contact branch</span>
  }

  if (!price?.formattedPrice) {
    return <span css={css`font-weight: 200;`}>Contact branch</span>
  }

  if (!price.isClearance) {
    return <span css={css`color: ${themeColors.grey};`}>{price.formattedPrice}</span>
  }

  return (
    <span
      css={css`
        display: inline-flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 8px;
        font-size: ${fontSize}px;
      `}
    >
      <span
        css={css`
          color: black;
          font-weight: 700;
        `}
      >
        {price.formattedPrice}
      </span>
      {price.originalFormattedPrice && (
        <span
          css={css`
            color: ${brandColors.red};
            text-decoration: line-through;
            font-weight: 400;
          `}
        >
          {price.originalFormattedPrice}
        </span>
      )}
      {price.discount != null && price.discount > 0 && (
        <span
          css={css`
            color: ${brandColors.red};
            font-weight: 600;
          `}
        >
          SAVE {price.discount}%
        </span>
      )}
    </span>
  )
}
